import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { useWeb3React } from "@web3-react/core";
import { projectContractsConfig } from "../../contracts/projectContractsConfig";

const Timer = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const project = localStorage.getItem("project");

  const timer = useCallback(
    async (roundId, version = null) => {
      try {
        // Handle NODEMINER special case
        if (project === "NODEMINER") {
          return 0;
        }

        const config = projectContractsConfig.find((p) => p.id === project);
        console.log(config, 'Error getting timer forError getting timer forError getting timer for');

        if (!config) {
          throw new Error(`Project configuration not found for: ${project}`);
        }

        // Determine which contract to use (versioned or default)
        let contractConfig;
        if (version) {
          const versionKey = `v${version}`;
          contractConfig = config.contracts[versionKey];

          if (!contractConfig) {
            throw new Error(`Version ${version} not found for project: ${project}`);
          }
        } else {
          contractConfig = config.contracts.preSale;
        }

        const contract = contractConfig.contract(contractConfig.address, web3);
        const roundData = await contract.methods.rounds(roundId).call();

        return roundData;
      } catch (error) {
        console.error(`Error getting timer for ${project}:`, error);
        throw error;
      }
    },
    [account, web3, project]
  );

  return { timer };
};

export default Timer;
// import { useCallback, useState } from "react";
// import useWeb3 from "../useWeb3";
// import {
//   getdoproundcreatecontract,
//   getGemsPreSaleContract,
//   getIncentivPreSaleContract,
//   getLEIAPreSaleContract,
//   getOlympusPreSaleContract,
//   getNFAPreSaleContract,
//   getAstroNovaPreSaleContract,
//   getAstroNovaPreSaleV2Contract,
//   getRainPreSaleContract,
//   getRainPreSaleV2Contract,
//   getRainPreSaleV3Contract,
//   getMatchainPreSaleContract,
//   getMinersClaimsContract,
//   getLuckifyPreSaleContract,
//   getScrexPreSaleContract

// } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
// import Environment from "../../utils/Environment";

// const Timer = () => {
//   const [balance, setBalance] = useState(null);
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const tokenAddress = Environment.DOPRoundSingleContract;
//   const contract = getdoproundcreatecontract(tokenAddress, web3);

//   const gemsAddress = Environment.GEMSPreSale;
//   const incentivAddress = Environment.IncentivPreSale;
//   const LEIAAddress = Environment.LEIAPreSale;
//   const OlympusAddress = Environment.OlympusPreSale;
//   const NFAAddress = Environment.NFAPreSale;
//   const AstroNovaAddress = Environment.AstroNovaPreSale;
//   const AstroNovaAddressV2 = Environment.AstroNovaPreSaleV2;

//   const RainAddress = Environment.RainPreSale;
//   const RainAddressV2 = Environment.RainPreSaleV2;
//   const RainAddressV3 = Environment.RainPreSaleV3;

//   const MatchainAddress = Environment.MATCHAINPreSale;


//   const MinersAddress = Environment.MinersPreSale;

//   const gemsContractPresale = getGemsPreSaleContract(gemsAddress, web3);
//   const incentivContractPresale = getIncentivPreSaleContract(
//     incentivAddress,
//     web3
//   );

//   const LEIAContractPresale = getLEIAPreSaleContract(LEIAAddress, web3);
//   const OlympusContractPresale = getOlympusPreSaleContract(
//     OlympusAddress,
//     web3
//   );
//   const NFAContractPresale = getNFAPreSaleContract(NFAAddress, web3);
//   const AstroNovaContractPresale = getAstroNovaPreSaleContract(
//     AstroNovaAddress,
//     web3
//   );
//   const AstroNovaContractPresaleV2 = getAstroNovaPreSaleV2Contract(
//     AstroNovaAddressV2,
//     web3
//   );

//   const RainContractPresale = getRainPreSaleContract(RainAddress, web3);

//   const RainContractPresaleV2 = getRainPreSaleV2Contract(RainAddressV2, web3);
//   const RainContractPresaleV3 = getRainPreSaleV3Contract(RainAddressV3, web3);

//   const MatchainContractPresale = getMatchainPreSaleContract(MatchainAddress, web3);
//   const LuckifyContractPresale = getLuckifyPreSaleContract(Environment.LUCKIFYPreSale, web3);
//   const ScrexContractPresale = getScrexPreSaleContract(Environment.SCREXPreSale, web3);
//   const ChainersContractPresale = getScrexPreSaleContract(Environment.CHAINERSPreSale, web3);
//   const MinersContractClaims = getMinersClaimsContract(MinersAddress, web3);


//   const project = localStorage.getItem("project");

//   const timer = useCallback(
//     async (e, nodeMinerVersion) => {
//       if (project == "MATCHAIN") {
//         try {
//           const buy = await MatchainContractPresale.methods.rounds(e).call();
//           return buy;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "LUCKIFY") {
//         try {
//           const buy = await LuckifyContractPresale.methods.rounds(e).call();
//           return buy;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "SCREX") {
//         try {
//           const buy = await ScrexContractPresale.methods.rounds(e).call();
//           return buy;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "CHAINERS") {
//         try {
//           const buy = await ChainersContractPresale.methods.rounds(e).call();
//           return buy;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "INCENTIV") {
//         try {
//           const buy = await incentivContractPresale.methods.rounds(e).call();
//           return buy;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "NFA") {
//         try {
//           const buy = await NFAContractPresale.methods.rounds(e).call();
//           return buy;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "ASTRANOVA") {
//         if (nodeMinerVersion == 1) {
//           try {
//             const buy = await AstroNovaContractPresale.methods.rounds(e).call();
//             return buy;
//           } catch (error) {
//             throw error;
//           }
//         } else if (nodeMinerVersion == 2) {
//           try {
//             const buy = await AstroNovaContractPresaleV2.methods
//               .rounds(e)
//               .call();
//             return buy;
//           } catch (error) {
//             throw error;
//           }
//         }
//       } else if (project == "RAIN") {
//         if (nodeMinerVersion == 1) {
//           try {
//             const buy = await RainContractPresale.methods.rounds(e).call();
//             return buy;
//           } catch (error) {
//             throw error;
//           }
//         } else if (nodeMinerVersion == 2) {
//           try {
//             const buy = await RainContractPresaleV2.methods.rounds(e).call();
//             return buy;
//           } catch (error) {
//             throw error;
//           }
//         } else if (nodeMinerVersion == 3) {
//           try {
//             const buy = await RainContractPresaleV3.methods.rounds(e).call();
//             return buy;
//           } catch (error) {
//             throw error;
//           }
//         }
//       } else if (project == "NODEMINER") {
//         try {
//           // const buy = await MinersContractClaims.methods.rounds(e).call();
//           return 0;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "LEIA") {
//         try {
//           const buy = await LEIAContractPresale.methods.rounds(e).call();
//           return buy;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "OLYMPUS") {
//         try {
//           const buy = await OlympusContractPresale.methods.rounds(e).call();
//           return buy;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "GEMS") {
//         try {
//           const buy = await gemsContractPresale.methods.rounds(e).call();
//           return buy;
//         } catch (error) {
//           throw error;
//         }
//       } else {
//         try {
//           const buy = await contract.methods.rounds(e).call();
//           return buy;
//         } catch (error) {
//           throw error;
//         }
//       }
//     },
//     [LEIAContractPresale, incentivContractPresale, account, web3]
//   );
//   return { timer: timer };
// };
// export default Timer;
